export const isValidPayAmount = (inputToValidate: string): boolean => {
  if (Number(inputToValidate) < 0 || /\D/gu.test(inputToValidate)) {
    return false;
  }
  return true;
};
